import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Tooltip,
  Paper,
  Grid,
  Tab,
  Tabs,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  TablePagination,
  Dialog,
  DialogTitle,
  Button,
  Divider,
} from "@mui/material";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import BroadCast from "./UnRead/BroadCast";
import ServiceAdv from "./UnRead/ServiceAdv";
import Spare from "./UnRead/Spare";
import TechDoc from "./UnRead/TechDoc";
import {
  readNotificationService,
  NotificationService,
  addBroadCastNotification,
  getNotificationCountService,
} from "../../services/NotificationService";
import Read from "./Read";
import Add from "@mui/icons-material/Add";
import AddBroadCast from "./UnRead/AddBroadCast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_BROADCAST_VALIDATIONS } from "../../utils/Validation";
import useGlobalState from "../../Context";
import { setNotificationsReadStatus } from "../../reducer/action";
import { useParams, useLocation, useHistory } from "react-router-dom";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3, ml: 2 }}>{children}</Box>}
    </div>
  );
};

const Notification = () => {
  const [{ auth, notificationsAccessRights }, dispatch] = useGlobalState();
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [value, setValue_] = React.useState(0);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [notificationRecords, setNotificationRecords] = useState([]);
  const [totalElements, setTotalElements] = useState();
  const [readUreadValue, setReadUreadValue] = useState("unread");
  const [openAddModelDialog, setOpenAddModelDialog] = useState(false);
  const [formData, setFormData] = useState({});
  const [broadcastLength, setBraodCastLength] = useState();
  const [serviceAdvLength, setServAdvLength] = useState();
  const [spareLength, setSpareLength] = useState();
  const [tecDocLength, setTechDocLength] = useState();
  const [broadcastTotalLength, setBraodTotalCastLength] = useState(0);
  const [serviceTotalAdvLength, setServTotalAdvLength] = useState(0);
  const [spareTotalLength, setSpareTotalLength] = useState(0);
  const [tecDocTotalLength, setTechTotalDocLength] = useState(0);
  const [defaultReadUnread, setDefaultOfReadUnread] = useState();
  const [broadCastDataCont, setBroadCastDataCont] = useState();
  const [noRecord, setNoRecord] = useState(false);
  const [tst, setTest] = useState();
  const inputFileRefunread = React.useRef();
  const inputFileRefread = React.useRef();
  const [file, setFile] = useState(null);
  const [editorNoVal, SetEditorNoVal] = useState(false);
  const filesFormats = ["doc", "docx", "xls", "xlsx", "pdf", "csv"];

  //const auth = JSON.parse(localStorage.getItem("SPMS_INTERNAL_STATE"));
  const notificationsAccessRightsTest = notificationsAccessRights;
  const loginUserType = auth?.ldapParam?.userType;
  const USERID = auth?.ldapParam?.userId;
  const DEPTID = auth?.ldapParam?.deptId;
  const { state } = useLocation();

  //move to read

  const handleMoveToReadFunc = async (newVal, _id) => {
    try {
      const requestObj = {
        broadcastNotificationRequest: newVal == 0 ? [_id] : [],
        serviceAdvNotificationRequest: newVal == 1 ? [_id] : [],
        spareNotificationRequest: newVal == 2 ? [_id] : [],
        techDocNotificationRequest: newVal == 3 ? [_id] : [],
        userId: USERID,
        userType: loginUserType,
      };
      // console.log('requestObj',requestObj)
      const notificationResponse = await readNotificationService(requestObj);
      if (notificationResponse.statusCode == "6") {
        // setDialog(false);
        // await fetchNotificationList();
        // setValue(0);
        //showNotification("Success", notificationResponse.message, "success");
        //dispatch(setNotificationsReadStatus(true));
        //fetchNotificationCounts();
      } else {
        //setDialog(false);
        // showNotification("Error", notificationResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to move to read");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = async (e, newValue) => {
    setNoRecord(false);
    setPage(0);
    await fetchNotificationList(0, newValue);
    setValue_(newValue);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(5);
    localStorage.removeItem("notifyBroadCast");
    localStorage.removeItem("NotifyserviceAdv");
    localStorage.removeItem("NotifySpare");
    localStorage.removeItem("NotifyTechDoc");
  };
  const formOption = {
    resolver: yupResolver(ADD_BROADCAST_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const { register, handleSubmit, formState, reset,setValue } = useForm(formOption);
  const { errors } = formState;
  useEffect(() => {
    if (state) {
      setValue_(state?.typeId);
      fetchNotificationList(0, state?.typeId);

      if (state?.isFromRead) {
        setDefaultOfReadUnread("Read");
        setReadUreadValue("Read");
        inputFileRefread.current.click();
      } else {
        setDefaultOfReadUnread("unread");
        setReadUreadValue("unread");
        inputFileRefunread.current.click();
      }
    } else {
      fetchNotificationList();
    }
    //fetchNotificationList()
  }, []);

  const handleRadioChange = (event) => {
    setReadUreadValue(event.target.value);
  };

  const handleClose = () => {
    setOpenAddModelDialog(false);

    setFormData({});
  };

  const handleTableChanges = async (paginationValues, isUpdate) => {
    try {
      setLoading(true);
      const requestObj = {
        userId: USERID,
        userType: loginUserType,
        notificationType: value ? value : 0,
        fetchPageRequest: {
          pageNumber: paginationValues?.pageNumber ?? 0,
          pageSize: paginationValues?.pageSize ?? 10,
          sortDirection: "DESC",
          sortBy: null,
          filterSearch: null,
          active: loginUserType === "Main Admin" ? 2 : 0,
        },
        deptId: DEPTID,
        read: false,
      };
      const notificationResponse = await NotificationService(requestObj);
      if (notificationResponse.statusCode === 6) {
        if (isUpdate) {
          setNotificationRecords([
            ...notificationRecords,
            ...notificationResponse.data.fetchNotificationResponses.content,
          ]);
          setTotalElements(
            notificationResponse.data.fetchNotificationResponses.totalElements
          );
          setBraodTotalCastLength(
            notificationResponse.data.notificationCountResponse.broadcastCount
          );
          setServTotalAdvLength(
            notificationResponse.data.notificationCountResponse.serviceAdvCount
          );
          setSpareTotalLength(
            notificationResponse.data.notificationCountResponse.spareCount
          );
          setTechTotalDocLength(
            notificationResponse.data.notificationCountResponse.techDocCount
          );
        } else {
          setBraodTotalCastLength(
            notificationResponse.data.notificationCountResponse.broadcastCount
          );
          setServTotalAdvLength(
            notificationResponse.data.notificationCountResponse.serviceAdvCount
          );
          setSpareTotalLength(
            notificationResponse.data.notificationCountResponse.spareCount
          );
          setTechTotalDocLength(
            notificationResponse.data.notificationCountResponse.techDocCount
          );
          setNotificationRecords(
            notificationResponse.data.fetchNotificationResponses.content
          );
          setTotalElements(
            notificationResponse.data.fetchNotificationResponses.totalElements
          );
        }
      } else {
        showNotification("Error", notificationResponse.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      //setTableLoader(false);
    }
  };

  const fetchNotificationList = async (page, notificationType) => {
    try {
      setLoading(true);
      const requestObj = {
        userId: USERID,
        userType: loginUserType,
        notificationType: notificationType ? notificationType : 0,
        fetchPageRequest: {
          pageSize: 5,
          pageNumber: page ? page : 0,
          sortDirection: "DESC",
          sortBy: null,
          filterSearch: null,
          active: loginUserType === "Main Admin" ? 2 : 0,
        },
        deptId: DEPTID,
        read: false,
      };
      const notificationResponse = await NotificationService(requestObj);
      if (notificationResponse.statusCode === 6) {
        setBraodTotalCastLength(
          notificationResponse.data.notificationCountResponse.broadcastCount
        );
        setServTotalAdvLength(
          notificationResponse.data.notificationCountResponse.serviceAdvCount
        );
        setSpareTotalLength(
          notificationResponse.data.notificationCountResponse.spareCount
        );
        setTechTotalDocLength(
          notificationResponse.data.notificationCountResponse.techDocCount
        );
        if (
          notificationResponse.data.fetchNotificationResponses.content
            ?.length === 0
        ) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        if (
          notificationResponse.data.notificationCountResponse.broadcastCount ===
            0 &&
          notificationResponse.data.notificationCountResponse
            .serviceAdvCount === 0 &&
          notificationResponse.data.notificationCountResponse.spareCount ===
            0 &&
          notificationResponse.data.notificationCountResponse.techDocCount === 0
        ) {
          //setTest('Read')

          dispatch(setNotificationsReadStatus(true));
          if (!state) {
            setDefaultOfReadUnread("Read");
            setReadUreadValue("Read");
            inputFileRefread.current.click();
          }
        } else {
          setTest("unread");
          await dispatch(setNotificationsReadStatus(false));
          if (!state) {
            setDefaultOfReadUnread("unread");
            setReadUreadValue("unread");
            inputFileRefunread.current.click();
          }
        }

        setNotificationRecords(
          notificationResponse?.data.fetchNotificationResponses.content
        );
        setTotalElements(
          notificationResponse?.data.fetchNotificationResponses.totalElements
        );
      } else {
        showNotification("Error", notificationResponse.message, "error");
      }
    } catch (err) {
      console.log("error in list", err);
      showNotification(
        "Error",
        err.message ?? "Failed to fetch notification details"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchNotificationCounts = async () => {
    try {
      setLoading(true);
      const requestObj = {
        userId: USERID,
        read: false,
        userType: loginUserType,
      };
      const response = await getNotificationCountService(requestObj);
      if (response.statusCode === 6) {
        fetchNotificationList();
        setBraodTotalCastLength(response.data.broadcastCount);
        setServTotalAdvLength(response.data.serviceAdvCount);
        setSpareTotalLength(response.data.spareCount);
        setTechTotalDocLength(response.data.techDocCount);
        if (
          response.data.broadcastCount === 0 &&
          response.data.serviceAdvCount === 0 &&
          response.data.spareCount === 0 &&
          response.data.techDocCount === 0
        ) {
          //setTest('Read')
          dispatch(setNotificationsReadStatus(true));
          setDefaultOfReadUnread("Read");
          setReadUreadValue("Read");
          inputFileRefread.current.click();
        } else {
          setTest("unread");
          dispatch(setNotificationsReadStatus(false));
          setDefaultOfReadUnread("unread");
          setReadUreadValue("unread");
          inputFileRefunread.current.click();
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error in count api", err);
      showNotification(
        "Error",
        err.message ?? "Failed to fetch notification details"
      );
    } finally {
      setLoading(false);
    }
  };

  const onSubmitBroadCast = async (data) => {
    try {
      setLoading(true);
      const fileName = file?.name;
      var ext = fileName?.substr(fileName?.lastIndexOf(".") + 1);
      const isRightFormat = filesFormats?.includes(file && ext);
      const requestObj = {
        notificationType: 0,
        notificationTypeId: 0,
        title: data.title,
        content: broadCastDataCont ?? "",
        createdOn: new Date(),
        createdBy: auth?.ldapParam?.userId,
        modifiedOn: new Date(),
        modifiedBy: 0,
        isActive: true,
        isDownloadAble: true,
        uploadDoc: file ? true : false,
      };

      if (broadCastDataCont == undefined || broadCastDataCont.length <= 0 ) {
        SetEditorNoVal(true);
        setBroadCastDataCont(null);
        return;
      }
      if(broadCastDataCont.startsWith('"') && broadCastDataCont.endsWith('"') && broadCastDataCont.length <= 2){
        SetEditorNoVal(true);
        setBroadCastDataCont(null);
        return;
      }
      if (broadCastDataCont.length > 65530) {
        SetEditorNoVal(true);
        showNotification(
          "Error",
          "content max size should be 65530 only",
          "error"
        );
        return;
      }
      // if (broadCastDataCont.match("/^(?![=/ ])[^\n]+$/")) {
      //   SetEditorNoVal(true);
      //   showNotification("Error", "Field can not start with = or /", "error");

      //   return;
      // }
      if (file && !isRightFormat) {
        showNotification(
          "Error",
          "You can only upload pdf,doc. docx and excel files",
          "error"
        );
        setFile(null);
        return;
      }
      if (file) {
        if ((file?.size > 2097152)) {
          showNotification(
            "Error",
            "File size should not be greater than 2MB",
            "error"
          );
          return;
        }
      }

      if (broadCastDataCont == undefined || broadCastDataCont.length <= 0) {
        showNotification(
          "Error",
          "Please provide some broadcast details",
          "error"
        );
        setFile(null);
        return;
      }

      const notificationResponse = await addBroadCastNotification(
        file,
        requestObj
      );
      if (notificationResponse.statusCode == "6") {
        setPage(0);
        await fetchNotificationList(0, 0);
        showNotification("Success", notificationResponse.message, "success");
        setOpenAddModelDialog(false);
        setValue_(0);
        setMaxPage(0);
        setFile(null);
        reset();
        SetEditorNoVal(false);
      } else {
        showNotification("Error", notificationResponse.message, "error");
        setOpenAddModelDialog(false);
      }
    } catch (err) {
      showNotification(
        "Error",
        err.message ?? "Failed to fetch notification details"
      );
      setOpenAddModelDialog(false);
    } finally {
      setLoading(false);
    }
  };
  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };

    await handleTableChanges(paginationValues, false);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(paginationValues, true);
    }
    setPage(newPage);
  };
  const handleClickOpenOnAdd = async () => {
    setBroadCastDataCont();
    reset(formData);
    setOpenAddModelDialog(true);
  };
  const TabWithCount = ({ children, count }) => {
    return (
      <Box sx={{ display: "inline-flex", alignItems: "center" }}>
        <Typography component="div">{children}</Typography>
        {count ? (
          <Typography
            component="div"
            variant="body2"
            sx={{ marginLeft: "0.5rem", fontSize: "1rem" }}>
            {count}
          </Typography>
        ) : null}
      </Box>
    );
  };
  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 8, ml: 0 }}>
        <Grid container spacing={1} sx={{ px: 0, mb: 0 }} display="flex">
          <Grid item xs={8} sx={{ mb: 0 }}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6">
              Notifications
            </Typography>
          </Grid>
          <Grid container align="left" item xs={12}>
            <Grid item xs={5} align="left">
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="unread"
                  name="radio-buttons-group"
                  onChange={handleRadioChange}>
                  <FormControlLabel
                    value="unread"
                    control={<Radio />}
                    label="Unread"
                    ref={inputFileRefunread}
                  />
                  <FormControlLabel
                    value="Read"
                    control={<Radio />}
                    label="Read"
                    ref={inputFileRefread}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={7} align="right">
              {loginUserType === "Main Admin" ||
              loginUserType === "Domain Admin" ? (
                <Tooltip title="Add Broadcast">
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleClickOpenOnAdd();
                    }}
                    className="button-primary-alt-contained"
                    startIcon={<Add />}>
                    Add Broadcast
                  </Button>
                </Tooltip>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
        {readUreadValue == "unread" ? (
          <Paper elevation={4} sx={{ width: "100%", overflow: "hidden" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="fullWidth"
              aria-label="full width tabs example"
              centered
              className="notificationBlock">
              <Tab
                label={
                  <TabWithCount count={`( ${broadcastTotalLength} )`}>
                    Broadcast
                  </TabWithCount>
                }
              />
              <Tab
                label={
                  <TabWithCount count={`( ${serviceTotalAdvLength} )`}>
                    Service Adv
                  </TabWithCount>
                }
              />
              <Tab
                label={
                  <TabWithCount count={`( ${spareTotalLength} )`}>
                    Spare
                  </TabWithCount>
                }
              />
              <Tab
                label={
                  <TabWithCount count={`( ${tecDocTotalLength} )`}>
                    Technical Doc
                  </TabWithCount>
                }
              />
            </Tabs>
            <TabPanel value={value} index={0}>
              <BroadCast
                notificationRecords={notificationRecords}
                noRecord={noRecord}
                totalElements={totalElements}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPage={rowsPerPage}
                page={page}
                setBraodCastLength={setBraodCastLength}
                handleMoveToReadFunc={handleMoveToReadFunc}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <ServiceAdv
                notificationRecords={notificationRecords}
                totalElements={totalElements}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPage={rowsPerPage}
                page={page}
                setServAdvLength={setServAdvLength}
                handleMoveToReadFunc={handleMoveToReadFunc}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Spare
                notificationRecords={notificationRecords}
                totalElements={totalElements}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPage={rowsPerPage}
                page={page}
                setSpareLength={setSpareLength}
                handleMoveToReadFunc={handleMoveToReadFunc}
              />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <TechDoc
                notificationRecords={notificationRecords}
                totalElements={totalElements}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPage={rowsPerPage}
                page={page}
                setTechDocLength={setTechDocLength}
                handleMoveToReadFunc={handleMoveToReadFunc}
              />
            </TabPanel>
            {notificationRecords.length > 0 ? (
              <Grid
                container
                align="left"
                sx={{
                  px: 2,
                  p: 1,
                  pb: 0,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
                item
                xs={12}>
                <Grid item xs={12} align="left">
                  {notificationRecords && totalElements > 5 ? (
                    <TablePagination
                      className="newPagination"
                      rowsPerPageOptions={[5, 10, 50, 100]}
                      component="div"
                      count={totalElements}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  ) : null}
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </Paper>
        ) : (
          <Read state={state} />
        )}
        <AddBroadCast
          openDialog={openAddModelDialog}
          handleClose={handleClose}
          register={register}
          handleSubmit={handleSubmit}
          errors={errors}
          formData={formData}
          onSubmitBroadCast={onSubmitBroadCast}
          setBroadCastDataCont={setBroadCastDataCont}
          editorNoVal={editorNoVal}
          setFile={setFile}
          setValue = {setValue}
        />
      </Container>
    </>
  );
};

export default Notification;
